export default "__VITE_ASSET__CqlQc1mq__";